import { motion } from "framer-motion";
import { Compass, MessageSquareText, UserCheck, Lightbulb, Briefcase } from "lucide-react";

const VALUES = [
  { icon: Compass, title: "Market-Focused Insights", body: "Coverage built around the unlisted space — not an afterthought to listed equities." },
  { icon: MessageSquareText, title: "Transparent Communication", body: "Clear pricing, clear process, clear risks. No jargon, no hidden layers." },
  { icon: UserCheck, title: "Dedicated Investor Support", body: "A named desk contact who stays with you through the entire journey." },
  { icon: Lightbulb, title: "Easy-to-Understand Information", body: "Research translated into language any investor can act on confidently." },
  { icon: Briefcase, title: "Professional Assistance", body: "Structured help with documentation, transfers and settlement — start to finish." },
];

export const WhyUs = () => {
  return (
    <section id="why-us" className="border-t border-slate-200 bg-[#FAF9FF] py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between"
        >
          <div>
            <p className="font-mono2 text-[11px] uppercase tracking-[0.35em] text-[#6D28D9]/90">Why Choose Us</p>
            <h2 className="font-display mt-4 text-3xl font-semibold tracking-tight text-slate-900 sm:text-4xl lg:text-5xl">
              The PRE-IPO EXPERT <span className="gold-text">standard</span>
            </h2>
          </div>
          <p className="max-w-md text-sm leading-relaxed text-slate-500">
            Five commitments that define every interaction with our desk.
          </p>
        </motion.div>

        <div className="mt-14 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-5">
          {VALUES.map((v, i) => (
            <motion.div
              key={v.title}
              data-testid={`why-us-card-${i}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.08 }}
              className="card-glow group border border-slate-200 bg-[#F6F4FD]/70 p-7 backdrop-blur"
            >
              <p className="font-display text-4xl font-semibold text-slate-200 transition-colors duration-500 group-hover:text-[#6D28D9]/40">
                0{i + 1}
              </p>
              <v.icon className="mt-6 h-5 w-5 text-[#6D28D9]" />
              <h3 className="font-display mt-4 text-base font-medium leading-snug text-slate-900">{v.title}</h3>
              <p className="mt-3 text-xs leading-relaxed text-slate-500">{v.body}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
